import React, { useState, useEffect } from 'react';
import { 
  obtenerVerificacionPorCaso, 
  actualizarItemVerificacion,
  PLANTILLA_VERIFICACION 
} from '../../services/verificacionService';
import './ChecklistVerificacion.css';

const ChecklistVerificacion = ({ casoId }) => {
  const [verificacion, setVerificacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState(null);

  useEffect(() => {
    if (casoId) {
      cargarVerificacion();
    }
  }, [casoId]);

  const cargarVerificacion = async () => {
    try {
      setLoading(true);
      const data = await obtenerVerificacionPorCaso(casoId);
      if (data) {
        setVerificacion(data);
      }
    } catch (error) {
      console.error('Error al cargar verificación:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = async (item, campo, valor) => {
    try {
      const updateData = {
        [campo]: valor,
        fecha: new Date() 
      };
      
      await actualizarItemVerificacion(verificacion.id, item, updateData);
      
    
      setVerificacion(prev => ({
        ...prev,
        [item]: {
          ...prev[item],
          [campo]: valor,
          fecha: new Date() 
        }
      }));
    } catch (error) {
      alert('Error al actualizar: ' + error.message);
    }
  };

  const handleObservacionChange = async (item, observaciones) => {
    try {
      await actualizarItemVerificacion(verificacion.id, item, { observaciones });
      setVerificacion(prev => ({
        ...prev,
        [item]: {
          ...prev[item],
          observaciones
        }
      }));
      setEditando(null);
    } catch (error) {
      alert('Error al guardar observación: ' + error.message);
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    
    if (fecha instanceof Date) {
      return fecha.toLocaleDateString();
    }
    
    if (fecha.toDate && typeof fecha.toDate === 'function') {
      return fecha.toDate().toLocaleDateString();
    }
    
    try {
      return new Date(fecha).toLocaleDateString();
    } catch {
      return '';
    }
  };

  const renderItem = (itemKey, itemData, titulo) => {
    const isEditing = editando === itemKey;

    return (
      <div className={`checklist-item ${itemData.verificada ? 'completado' : ''}`}>
        <div className="checklist-item-header">
          <div className="checklist-titulo">
            <input
              type="checkbox"
              checked={itemData.verificada || false}
              onChange={(e) => handleCheckboxChange(itemKey, 'verificada', e.target.checked)}
            />
            <h4>{titulo}</h4>
          </div>
          {itemData.fecha && (
            <span className="checklist-fecha">
              {formatearFecha(itemData.fecha)}
            </span>
          )}
        </div>

        {}
        {itemKey === 'runt' && itemData.verificada && (
          <div className="checklist-detalle">
            <label>Resultado:</label>
            <input
              type="text"
              value={itemData.resultado || ''}
              onChange={(e) => handleCheckboxChange(itemKey, 'resultado', e.target.value)}
              placeholder="Ej: OK, Pendiente, etc."
            />
          </div>
        )}

        {itemKey === 'simit' && itemData.verificada && (
          <div className="checklist-detalle">
            <label>
              <input
                type="checkbox"
                checked={itemData.multas || false}
                onChange={(e) => handleCheckboxChange(itemKey, 'multas', e.target.checked)}
              />
              Tiene multas
            </label>
          </div>
        )}

        {itemKey === 'embargos' && itemData.verificada && (
          <div className="checklist-detalle">
            <label>
              <input
                type="checkbox"
                checked={itemData.tieneEmbargos || false}
                onChange={(e) => handleCheckboxChange(itemKey, 'tieneEmbargos', e.target.checked)}
              />
              Tiene embargos
            </label>
          </div>
        )}

        {itemKey === 'improntas' && itemData.verificada && (
          <div className="checklist-detalle">
            <label>
              <input
                type="checkbox"
                checked={itemData.coinciden || false}
                onChange={(e) => handleCheckboxChange(itemKey, 'coinciden', e.target.checked)}
              />
              Coinciden las improntas
            </label>
          </div>
        )}

        {(itemKey === 'soat' || itemKey === 'tecnomecanica') && itemData.verificada && (
          <div className="checklist-detalle">
            <div className="form-row">
              <label>
                <input
                  type="checkbox"
                  checked={itemData.vigente || false}
                  onChange={(e) => handleCheckboxChange(itemKey, 'vigente', e.target.checked)}
                />
                Vigente
              </label>
              {itemData.vigente && (
                <div className="form-group">
                  <label>Fecha de vencimiento:</label>
                  <input
                    type="date"
                    value={itemData.fechaVencimiento ? formatearFecha(itemData.fechaVencimiento) : ''}
                    onChange={(e) => handleCheckboxChange(itemKey, 'fechaVencimiento', new Date(e.target.value))}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {}
        <div className="checklist-observaciones">
          {isEditing ? (
            <div className="observaciones-edit">
              <textarea
                defaultValue={itemData.observaciones || ''}
                rows="2"
                placeholder="Agregar observaciones..."
              />
              <div className="observaciones-actions">
                <button 
                  className="btn-guardar"
                  onClick={(e) => {
                    const textarea = e.target.parentNode.parentNode.querySelector('textarea');
                    handleObservacionChange(itemKey, textarea.value);
                  }}
                >
                  Guardar
                </button>
                <button 
                  className="btn-cancelar"
                  onClick={() => setEditando(null)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          ) : (
            <div className="observaciones-view">
              {itemData.observaciones ? (
                <p>{itemData.observaciones}</p>
              ) : (
                <p className="sin-observaciones">Sin observaciones</p>
              )}
              <button 
                className="btn-editar-obs"
                onClick={() => setEditando(itemKey)}
              >
                ✎
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) return <div className="loading">Cargando checklist...</div>;
  if (!verificacion) return <div className="error">No hay checklist para este caso</div>;

  const itemsCompletados = Object.values(verificacion).filter(v => v && v.verificada).length;
  const totalItems = 6; 
  const porcentaje = (itemsCompletados / totalItems) * 100;

  return (
    <div className="checklist-container">
      <h2>Checklist de Verificación Legal</h2>
      <div className="checklist-progreso">
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${porcentaje}%` }}
          />
        </div>
        <span>
          {itemsCompletados} de {totalItems} verificaciones completadas
        </span>
      </div>

      <div className="checklist-grid">
        {verificacion.runt && renderItem('runt', verificacion.runt, 'Verificación RUNT')}
        {verificacion.simit && renderItem('simit', verificacion.simit, 'Consulta SIMIT (Multas)')}
        {verificacion.embargos && renderItem('embargos', verificacion.embargos, 'Consulta de Embargos')}
        {verificacion.improntas && renderItem('improntas', verificacion.improntas, 'Validación de Improntas')}
        {verificacion.soat && renderItem('soat', verificacion.soat, 'Verificación SOAT')}
        {verificacion.tecnomecanica && renderItem('tecnomecanica', verificacion.tecnomecanica, 'Verificación TecnoMecánica')}
      </div>
    </div>
  );
};

export default ChecklistVerificacion;